import * as yup from 'yup'

export const contactBostadsratternaSchema = yup
  .object({
    message: yup.string().required(),
    shareInformation: yup.boolean().required(),
  })
  .required()
